import axios from "axios";
import { MAIN_URL } from "../../constants";
import { useNavigate } from "react-router-dom";

const api = axios.create({
    baseURL: MAIN_URL,
});


api.interceptors.response.use(
    response => response,
    async (error) => {
        if (error.response && error.response.status === 401 && !error.config._retry) {
            error.config._retry = true; 

            try {
                const refreshResponse = await axios.post(`${MAIN_URL}/staff/token/refresh`, {}, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("refresh_token")}`,
                        "Content-Type": "application/json"
                    }
                });
                const newToken = refreshResponse.data.access_token;
                const newRefreshToken = refreshResponse.data.refresh_token
                const refreshRole = refreshResponse.data.role
                localStorage.setItem("admin_token", newToken);
                localStorage.setItem("role", refreshRole)
                localStorage.setItem("refresh_token", newRefreshToken)

                if (!error.config.headers) {
                    error.config.headers = {};
                }
                error.config.headers["Authorization"] = `Bearer ${newToken}`;
                error.config.withCredentials = true;
                window.location.reload();
                return axios(error.config);
            } catch (refreshError) {
                console.log("Refresh token ishlamadi:", refreshError);
                localStorage.removeItem("admin_token");
                localStorage.removeItem("refresh_token");
                window.location.href = "/login";
                return Promise.reject(refreshError);
            }
        }
        return Promise.reject(error);
    }
);


export default api;
